import styled from '@emotion/styled';

import { shouldForwardProp } from '@hrworks/design-system/utilities';
import { IconButton as _IconButton } from '@hrworks/sui-core/IconButton';

const Wrapper = styled.div<{
  direction: 'prev' | 'next';
}>(({ direction, theme }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.stellenportal?.style?.backgroundColor || theme.eclipseTier2Color.surface.base,
  width: 51,
  ...(direction === 'prev' ? { left: 0 } : { right: 0 }),
}));

const IconButton = styled(_IconButton, {
  shouldForwardProp,
})<{ $direction: 'prev' | 'next' }>(({ $direction, theme }) => ({
  color: theme.stellenportal?.fontStyle?.color || theme.eclipseTier2Color.text.brand.default,
  rotate: $direction === 'prev' ? '90deg' : '-90deg',
  transition: `translate ${theme.variables.animationDuration.normal}`,

  ':hover, :focus-visible': {
    translate: $direction === 'prev' ? '-2px' : '2px',
  },
}));

export const S = { Wrapper, IconButton } as const;
